import AuthRepository from "./Api/AuthRepository";
import ProfileRepository from "./Api/ProfileRepository";
import FileRepository from "./Api/FileRepository";
import NotificationConfigRepository from "./Api/NotificationConfigRepository";
import PartnersShipRepository from "./Api/PartnersShipRepository";
import OperatorRepository from "./Api/OperatorRepository";
import RoleRepository from "./Api/RoleRepository";
import PermissionRepository from "./Api/PermissionRepository";
import BusinessTypeRepository from "./Api/BusinessTypeRepository";
import RegisterRepository from "./Api/RegisterRepository";
import ForgotPasswordRepository from "./Api/ForgotPasswordRepository";
import MerchantRepository from "./Api/MerchantRepository";
import ChatWidgetRepository from "./Api/ChatWidgetRepository";
import IntegrationRepository from "./Api/IntegrationRepository";
import ChatChannelRepository from "./Api/ChatChannelRepository";
import ChatMessageRepository from "./Api/ChatMessageRepository";
import ChatOperatorRepository from "./Api/ChatOperatorRepository";
import DashboardRepository from "./Api/DashboardRepository";
import NotificationRepository from "./Api/NotificationRepository";
import SubscriptionRepository from "./Api/SubscriptionRepository";
import ConversationOverviewRepository from "./Api/ConversationOverviewRepository";
import TeamPerformanceRepository from "./Api/TeamPerformanceRepository";
import CustomerSatificationRepository from "./Api/CustomerSatificationRepository";
import QuickMessageRepository from "./Api/QuickMessageRepository";
import ChatAssignmentRespository from "./Api/ChatAssignmentRespository";
import ChatSettingsRepository from "./Api/ChatSettingsRepository";
import TranslateRepository from "./Api/TranslateRepository";
import QueueRepository from "./Api/QueueRepository";
import BotRepository from "./Api/BotRepository";
import CallCenterRepository from "./Api/CallCenterRepository";
import CallRepository from "./Api/CallRepository";
import ReportRepository from "./Api/ReportRepository";
import CallSatisfactionRepository from "./Api/CallSatisfactionRepository";
import CallOperatorRepository from "./Api/CallOperatorRepository";
import ChatMeRoomRepository from "./Api/ChatMeRoomRepository";
import SpeechAlertRepository from "./Api/VoiceAlertSettingsRepository";
import ChatAgentRepository from "./Api/ChatAgentRepository";
import DepartmentRepository from "./Api/DepartmentRepository";
import EmployeeRepository from "./Api/EmployeeRepository";
import HolidayRepository from "./Api/HolidayRepository";
import QuestionRepository from "./Api/QuestionRepository";
import FrequentlyQuestionRepository from "./Api/FrequentlyQuestionRepository";
import TopicSummaryRepository from "./Api/TopicSummaryRepository";
import ServiceSystemRepository from "./Api/ServiceSystemRepository";
import EmployeePerformanceOverview from "./Api/EmployeePerformanceOverview";
import TimeShiftRepository from './Api/TimeShiftRepository'
import DayOffRepository from './Api/DayOffRepository'
import TakeLeaveRepository from './Api/TakeLeaveRepository'
import WorkingScheduleTemplateRepository from './Api/WorkingScheduleTemplateRepository'
import ProjectRepository from "./Api/ProjectRepository";
import TeamRepository from './Api/TeamRepository'
import ServiceCategoryRepository from "./Api/ServiceCategoryRepository";
import ServiceTypeRepository from "./Api/ServiceTypeRepository";
import TeamMemberRepository from './Api/TeamMemberRepository'
import OperatorForServiceRepository from "./Api/OperatorForServiceRepository";
import AllOperatorRepository from "./Api/AllOperatorRepository";
import EmployeeDepartmentRepository from "./Api/EmployeeDepartment";
import BreakTimRepository from "./Api/BreakTimeRepository";
import ServiceSubTypeRepository from "./Api/ServiceSubTypeRepository";
import WhitelistIPRepository from "./Api/WhitelistIPRepository";
import ThirdPartyRepository from "./Api/ThirdPartyRepository";
import ThirdPartyEnterpriseRepository from "./Api/ThirdPartyEnterpriseRepository";
import ShortcutRepository from "./Api/ShortcutRepository";

const repositories = {
  auth: AuthRepository,
  profile: ProfileRepository,
  file: FileRepository,
  notificationConfig: NotificationConfigRepository,
  partnersShip: PartnersShipRepository,
  operator: OperatorRepository,
  role: RoleRepository,
  permission: PermissionRepository,
  businessType: BusinessTypeRepository,
  register: RegisterRepository,
  forgotPassword: ForgotPasswordRepository,
  merchant: MerchantRepository,
  chatWidget: ChatWidgetRepository,
  integration: IntegrationRepository,
  chatChannel: ChatChannelRepository,
  chatMessage: ChatMessageRepository,
  chatOperator: ChatOperatorRepository,
  dashboard: DashboardRepository,
  notification: NotificationRepository,
  subscription: SubscriptionRepository,
  conversationOverview: ConversationOverviewRepository,
  teamPerformance: TeamPerformanceRepository,
  customerSatification: CustomerSatificationRepository,
  quickMessage: QuickMessageRepository,
  chatAssignmentRepository: ChatAssignmentRespository,
  chatSettingsRepository: ChatSettingsRepository,
  translateRepository: TranslateRepository,
  queueRepository: QueueRepository,
  bot: BotRepository,
  callCenter: CallCenterRepository,
  call: CallRepository,
  report: ReportRepository,
  callSatisfactionRepository: CallSatisfactionRepository,
  callOperator: CallOperatorRepository,
  chatMeRoom: ChatMeRoomRepository,
  speechAlertRepository: SpeechAlertRepository,
  chatAgent: ChatAgentRepository,
  department: DepartmentRepository,
  employee: EmployeeRepository,
  holiday: HolidayRepository,
  question: QuestionRepository,
  frequentlyQuestion: FrequentlyQuestionRepository,
  topicSummary: TopicSummaryRepository,
  serviceSystem: ServiceSystemRepository,
  employeePerformanceOverview: EmployeePerformanceOverview,
  timeShift: TimeShiftRepository,
  dayOff: DayOffRepository,
  takeLeave: TakeLeaveRepository,
  workingScheduleTemplate: WorkingScheduleTemplateRepository,
  project: ProjectRepository,
  team: TeamRepository,
  serviceCategory: ServiceCategoryRepository,
  serviceType: ServiceTypeRepository,
  serviceSubType: ServiceSubTypeRepository,
  teamMember: TeamMemberRepository,
  operatorForService: OperatorForServiceRepository,
  allOperator: AllOperatorRepository,
  employeeDepartment: EmployeeDepartmentRepository,
  breakTime: BreakTimRepository,
  whitelistIP: WhitelistIPRepository,
  thirdParty: ThirdPartyRepository,
  thirdPartyEnterprise: ThirdPartyEnterpriseRepository,
  shortcutRepo: ShortcutRepository,
};

export default {
  get: (name) => repositories[name],
};
